// Browser / device platform helpers (iPad vs Android vs desktop, standalone, etc).

export function isIOS() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  // iPadOS 13+ identifies as Mac; detect via touch points
  const isAppleTouchMac = /Macintosh/.test(ua) && navigator.maxTouchPoints > 1;
  return /iPad|iPhone|iPod/.test(ua) || isAppleTouchMac;
}

export function isIPad() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  if (/iPad/.test(ua)) return true;
  // iPadOS 13+ pretends to be a Mac; differentiate via touch + screen size
  return /Macintosh/.test(ua) && navigator.maxTouchPoints > 1;
}

export function isSafariBrowser() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  return /^((?!chrome|android|crios|fxios|edgios).)*safari/i.test(ua);
}

export function isStandalone() {
  if (typeof window === "undefined") return false;
  // iOS uses navigator.standalone, others use display-mode
  if (window.navigator?.standalone === true) return true;
  return !!(window.matchMedia && window.matchMedia("(display-mode: standalone)").matches);
}

export function isAndroid() {
  if (typeof navigator === "undefined") return false;
  return /Android/i.test(navigator.userAgent || "");
}

/** True when running inside a native iOS Capacitor wrapper (App Store build).
 *  Apple's Reader-app exception (Guideline 3.1.3(a)) requires us to hide all
 *  pricing/sign-up CTAs in the iOS build to avoid their 15-30% IAP cut. */
export function isIOSAppBuild() {
  if (typeof window === "undefined") return false;
  const cap = window.Capacitor;
  if (!cap) return false;
  try {
    if (typeof cap.getPlatform === "function") return cap.getPlatform() === "ios";
    return cap.platform === "ios";
  } catch {
    return false;
  }
}

/** True for any native Capacitor wrapper (iOS or Android). */
export function isNativeApp() {
  if (typeof window === "undefined") return false;
  const cap = window.Capacitor;
  if (!cap) return false;
  try {
    if (typeof cap.isNativePlatform === "function") return cap.isNativePlatform();
    return cap.platform !== "web";
  } catch {
    return false;
  }
}
